import "./index.css";
import React from "react";
import loadImage from "blueimp-load-image";
import Switch from "react-switch";
import ReactSelect from "react-select";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import HexHover from "../../components/HexHover";
import VerificationModal from "./components/VerificationModal";
import ErrorModal from "./components/ErrorModal";
import { TerritoryIcons } from "../../Utils/Constants";

const phone_img = require("../../assets/media/profile/phone.png");
const profession_img = require("../../assets/media/profile/profession.png");
const user_img = require("../../assets/media/profile/avatar.png");
const ApproveIcon = require("../../assets/media/profile/done.png");
const uidIcon = require("../../assets/media/profile/uid.png");
const referralIcon = require("../../assets/media/profile/referral.png");
const ageIcon = require("../../images/profile/age.png");
const kycIcon = require("../../images/profile/kyc.png");
const selfieIcon = require("../../images/profile/selfie.png");
const idIcon = require("../../images/profile/id.png");
const superhero_img = require("../../images/profile/superhero.png");

const Styles = {
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
  }),
};

function isValidDate(dtValue2) {
  // your desired pattern
  var pattern = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
  var m = dtValue2.match(pattern);
  if (!m) return false;
  return true;
}

function _calculateAge(birthday) {
  // birthday is a date
  if (!birthday) return "";
  const [day, month, year] = birthday.split("/");
  const birth = new Date(`${year}-${month}-${day}`);
  var ageDifMs = Date.now() - birth.getTime();
  var ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: {},
      activated: false,
      editfield: "",
      editValue: "",
      brand_data: {},
      switchable: true,
      loading: true,
      isLinked: false,
      personal_profile: {},
      modalNumber: 0,
    };
  }
  componentDidMount() {
    const uid = localStorage.getItem("uid");
    const { brand = 0, role, username } = this.props.location.state;
    if (!this.props.location.state || !uid) {
      this.props.history.push("/");
      return;
    }

    this.setState({ username, role, brand, loading: true });

    Firebase.getBrandDataByID(brand, (brand_data) => {
      this.setState((prevState) => ({
        ...prevState,
        logo: brand_data.logo,
        icon: brand_data.icon,
        brand_name: brand_data.name,
        brand_url: brand_data.url,
        hex: brand_data.hex,
        brand_data,
        loading: false,
        is_property_brand: brand_data.is_property_brand
          ? brand_data.is_property_brand
          : false,
      }));
      Firebase.getAgencyData(uid, (profile) => {
        this.setState((prevState) => ({
          ...prevState,
          profile,
        }));
        localStorage.setItem("profile", JSON.stringify(profile));
        if (!profile.member_uid) return;
        Firebase.getUserDatafromUID(brand_data.name, profile.member_uid)
          .then((user_data) => {
            if (!user_data || !user_data.phonenumber) return;
            this.setState((prevState) => ({
              ...prevState,
              isLinked: true,
              loading: false,
              personal_profile: user_data,
            }));
          })
          .catch(() => this.setState({ loading: false }));
      });
    });
  }

  onMakeActivate = (activated) => {
    this.setState({ activated });
  };

  changeProfileData = async (field, value) => {
    let profile = localStorage.getItem("profile");
    let uid = localStorage.getItem("uid");
    if (!value) return;
    try {
      profile = JSON.parse(profile);
      const newProfile = { ...profile };
      newProfile[field] = value;
      localStorage.setItem("profile", JSON.stringify(newProfile));
      this.setState({ profile: newProfile });
      await Firebase.updateAgencyData(uid, newProfile);
    } catch (e) {
      console.log(e);
    }
  };

  onChangeProfileData = (field) => {
    const { editfield, editValue } = this.state;
    if (field === editfield) {
      this.changeProfileData(field, editValue);
      this.setState({ editfield: "" });
    } else {
      let profile = localStorage.getItem("profile");
      profile = JSON.parse(profile);
      this.setState({
        editfield: field,
        editValue: profile[field] || "",
      });
    }
  };

  changePersonalProfileData = async (field, value) => {
    const { uid } = this.props;
    const { personal_profile: profile, brand } = this.state;
    const { eco_id } = profile;
    if (!profile || !brand) {
      return;
    }
    if (!value) return;

    try {
      if (field === "dob" && !isValidDate(value)) {
      } else {
        if (eco_id) {
          await Firebase.updateEcoUser(eco_id, {
            [field]: value,
          });
        }
        let newProfile = { ...profile };
        newProfile[field] = value;
        if (field === "firstname") {
          await Firebase.updateUserById(uid, brand.name, {
            firstname: value,
            tokens: (profile.tokens || 0) + 500,
          });
          //save token history
          await Firebase.saveTokenHistory(brand.name, uid, {
            created: new Date(),
            amount: -500,
            type: "Update first name",
          });
          newProfile = {
            ...newProfile,
            tokens: (newProfile.tokens || 0) + 500,
          };
          localStorage.setItem("profile", JSON.stringify(newProfile));
        } else {
          localStorage.setItem("profile", JSON.stringify(newProfile));
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  onChangePersonalProfileData = (field) => {
    const { editfield, editValue, personal_profile } = this.state;
    if (field === editfield) {
      this.changePersonalProfileData(field, editValue);
      this.setState({ editfield: "" });
    } else {
      this.setState({
        editfield: field,
        editValue: personal_profile[field] || "",
      });
    }
  };

  selectedFile = async (e) => {
    let profile = localStorage.getItem("profile");
    let uid = localStorage.getItem("uid");
    if (!profile) {
      return;
    }
    profile = JSON.parse(profile);
    let _this = this;
    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      loadImage.parseMetaData(content, function (data) {
        //default image orientation
        var orientation = 0;
        if (data.exif) {
          orientation = data.exif.get("Orientation");
        }
        console.log(orientation);
        loadImage(
          content,
          async function (canvas) {
            var base64data = canvas.toDataURL("image/png");
            var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
            _this.setState({ content: img_src });
            console.log("content", img_src);
            let avatar_url = await Firebase.addAvatar(uid, img_src);
            console.log("avatar_url", avatar_url);
            Firebase.updateAgencyData(uid, {
              avatar_url: avatar_url,
            });
            const newProfile = { ...(profile || {}) };
            newProfile.avatar_url = avatar_url;
            localStorage.setItem("profile", JSON.stringify(newProfile));
            _this.setState({ profile: newProfile });
            let img_content = "data:image/jpeg;base64," + img_src;
            _this.setState({ img_content });
          },
          {
            canvas: true,
            meta: true,
          }
        );
      });
    }
  };

  onSuccess = (phoneNumber, avatar_url) => {
    const { brand_data, profile } = this.state;
    console.log(
      "🚀 ~ file: index.js:267 ~ Profile ~ brand_data:",
      phoneNumber,
      avatar_url
    );
    this.setState({ loading: true });
    Firebase.getUserDatafromPhoneNumber(
      brand_data.name || "Ecosystem",
      phoneNumber[0] === "+" ? phoneNumber : `+${phoneNumber}`
    )
      .then((user_data) => {
        console.log(
          "🚀 ~ file: index.js:279 ~ Profile ~ .then ~ user_data:",
          user_data
        );
        if (user_data) {
          const { id, data } = user_data;
          this.changeProfileData("member_uid", id);
          Firebase.updateUserData(brand_data.name || "Ecosystem", id, {
            avatar_url,
          });
          // this.changeProfileData("avatar_url", avatar_url);
          this.setState((prevState) => ({
            ...prevState,
            isLinked: true,
            loading: false,
            personal_profile: data,
            profile: { ...profile, avatar_url, member_uid: id },
          }));
        } else {
          Firebase.getUserDatafromPhoneNumber(
            "Ecosystem",
            phoneNumber[0] === "+" ? phoneNumber : `+${phoneNumber}`
          )
            .then((user_data) => {
              console.log(
                "🚀 ~ file: index.js:302 ~ Profile ~ ).then ~ user_data:",
                user_data
              );
              if (user_data) {
                const { id, data } = user_data;
                this.changeProfileData("member_uid", id);
                Firebase.updateUserData("Ecosystem", id, {
                  avatar_url,
                });
                // this.changeProfileData("avatar_url", avatar_url);
                this.setState((prevState) => ({
                  ...prevState,
                  isLinked: true,
                  loading: false,
                  personal_profile: data,
                  profile: { ...profile, avatar_url, member_uid: id },
                }));
              } else {
                this.setState({ loading: false });
              }
            })
            .catch((e) => {
              this.setState((prevState) => ({
                ...prevState,
                loading: false,
              }));
            });
        }
      })
      .catch((e) => {
        this.setState((prevState) => ({
          ...prevState,
          loading: false,
        }));
      });
  };

  render() {
    const {
      profile,
      img_content,
      editfield,
      editValue,
      logo,
      brand,
      loading,
      brand_name,
      switchable,
      is_property_brand,
      brand_data,
      isLinked,
      personal_profile,
      modalNumber,
    } = this.state;

    const HexButton = HexHover("button", brand_data ? brand_data.hex : "white");

    const uid = localStorage.getItem("uid");
    let { username = "", phonenumber } = profile || {};
    let { avatar_url } = personal_profile || {};
    let role = this.props.location.state.role;

    const { territory } = brand_data;
    const userTerritory = phonenumber
      ? phonenumber.startsWith("+1")
        ? "USA"
        : territory || "UK"
      : territory;

    if (!avatar_url) avatar_url = user_img;

    return (
      <React.Fragment>
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <div id="home-container" className="row no-gutters flex-md-10-auto">
          <div className="profile-content-container">
            {loading && (
              <div className="profile-loading-bar">
                <i className="fa fa-4x fa-sync fa-spin text-muted" />
              </div>
            )}
            {!loading && (
              <React.Fragment>
                <div className="content profile-content">
                  {!isLinked && (
                    <React.Fragment>
                      <div className="profile-right">
                        <div
                          className="personal-view"
                          style={{ marginTop: 20 }}
                        >
                          <div className="row_item">
                            <Switch
                              onChange={this.onMakeActivate}
                              checked={this.state.activated}
                              disabled={!switchable}
                            />
                            <p className="switch_label">
                              {this.state.activated
                                ? "Active in community"
                                : "Inactive in community"}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="profile-left">
                        <div className="personal_profile">
                          <div
                            className="personal_profile__avatar"
                            style={{
                              backgroundImage: `url(${
                                img_content ? img_content : avatar_url
                              })`,
                            }}
                            onClick={() => {
                              this.refs.fileUploader.click();
                            }}
                          ></div>
                          <div className="icons-container">
                            <img src={ApproveIcon} alt="active" />
                            <img
                              src={TerritoryIcons[userTerritory]}
                              alt="flag"
                            />
                          </div>
                          <div className="name-container">
                            {editfield === "username" ? (
                              <input
                                className="input_box"
                                type="text"
                                value={editValue === "demo" ? "" : editValue}
                                onChange={(e) =>
                                  this.setState({
                                    editValue: e.target.value,
                                  })
                                }
                              ></input>
                            ) : (
                              <p>
                                <b>{username}</b>
                              </p>
                            )}
                            <div
                              className="edit"
                              onClick={() =>
                                this.onChangeProfileData("username")
                              }
                            >
                              <i
                                className={
                                  editfield === "username"
                                    ? "si si-check"
                                    : "si si-settings"
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="personal-view">
                          <div className="row_item">
                            <img
                              src={phone_img}
                              width="30"
                              alt="phonenumber"
                            ></img>
                            <p className="row_item_value">
                              {phonenumber || "Light member"}
                            </p>
                          </div>
                          <div className="row_item">
                            <img src={uidIcon} width="30" alt="uid"></img>
                            <p className="row_item_value">
                              <span
                                style={{
                                  fontWeight: "bold",
                                  marginRight: "5px",
                                }}
                              >
                                UID
                              </span>
                              {uid}
                            </p>
                          </div>
                          <div className="row_item">
                            <img
                              src={referralIcon}
                              width="30"
                              alt="referral code"
                            ></img>
                            <p className="row_item_value">
                              <span
                                style={{
                                  fontWeight: "bold",
                                  marginRight: "5px",
                                }}
                              >
                                Referral code
                              </span>
                              {`${username
                                .slice(0, 2)
                                .toUpperCase()}${uid.slice(-6)}`}
                            </p>
                          </div>
                          <div className="row_item">
                            <img
                              src={profession_img}
                              width="30"
                              alt="profession"
                            ></img>
                            <p className="row_item_value">{brand_name}</p>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )}

                  {isLinked && (
                    <React.Fragment>
                      <div className="profile-right">
                        <div
                          className="personal-view"
                          style={{ marginTop: 20 }}
                        >
                          <div className="row_item">
                            <Switch
                              onChange={this.onMakeActivate}
                              checked={this.state.activated}
                              disabled={!switchable}
                            />
                            <p className="switch_label">
                              {this.state.activated
                                ? "Active in community"
                                : "Inactive in community"}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="profile-left">
                        <div className="personal_profile">
                          <div
                            className="personal_profile__avatar"
                            style={{
                              backgroundImage: `url(${
                                img_content ? img_content : avatar_url
                              })`,
                            }}
                            onClick={() => {
                              this.refs.fileUploader.click();
                            }}
                          ></div>
                          <div className="icons-container">
                            <img src={ApproveIcon} alt="active" />
                            <img
                              src={TerritoryIcons[userTerritory]}
                              alt="flag"
                            />
                          </div>
                          <div className="name-container">
                            {editfield === "firstname" ? (
                              <input
                                className="input_box"
                                type="text"
                                value={editValue === "demo" ? "" : editValue}
                                onChange={(e) =>
                                  this.setState({ editValue: e.target.value })
                                }
                              ></input>
                            ) : (
                              <p>
                                <b>{personal_profile.firstname}</b>
                              </p>
                            )}
                            <div
                              className="edit"
                              onClick={() =>
                                this.onChangePersonalProfileData("firstname")
                              }
                            >
                              <i
                                className={
                                  editfield === "firstname"
                                    ? "si si-check"
                                    : "si si-settings"
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="personal-view">
                          <div className="row_item">
                            <img
                              src={phone_img}
                              width="30"
                              alt="phonenumber"
                            ></img>
                            <p className="row_item_value">
                              {personal_profile.phonenumber || "Light member"}
                            </p>
                          </div>
                          <div className="row_item">
                            <img src={uidIcon} width="30" alt="uid"></img>
                            <p className="row_item_value">
                              <span
                                style={{
                                  fontWeight: "bold",
                                  marginRight: "5px",
                                }}
                              >
                                UID
                              </span>
                              {profile.uid}
                            </p>
                          </div>
                          <div className="row_item">
                            <img
                              src={referralIcon}
                              width="30"
                              alt="referral code"
                            ></img>
                            <p className="row_item_value">
                              <span
                                style={{
                                  fontWeight: "bold",
                                  marginRight: "5px",
                                }}
                              >
                                Referral code
                              </span>
                              {`${personal_profile.firstname
                                .slice(0, 2)
                                .toUpperCase()}${uid.slice(-6)}`}
                            </p>
                          </div>
                          <div className="row_item">
                            <img src={ageIcon} width="30" alt="age"></img>
                            <p className="row_item_value">
                              {editfield === "dob" ? (
                                <input
                                  className="input_box"
                                  type="text"
                                  placeholder="dd/mm/yyyy"
                                  value={editValue === "demo" ? "" : editValue}
                                  onChange={(e) =>
                                    this.setState({
                                      editValue: e.target.value,
                                    })
                                  }
                                ></input>
                              ) : (
                                `Age: ${_calculateAge(personal_profile.dob)}`
                              )}
                            </p>
                            <div
                              className="edit"
                              onClick={() =>
                                this.onChangePersonalProfileData("dob")
                              }
                            >
                              <i
                                className={
                                  editfield === "dob"
                                    ? "si si-check"
                                    : "si si-settings"
                                }
                              />
                            </div>
                          </div>
                          {/* <div className="row_item">
                            <img
                              src={kycIcon}
                              width="30"
                              alt="profession"
                            ></img>
                            <p className="row_item_value">Identity KYC</p>
                            <button
                              className="btn verify_btn"
                              style={{
                                backgroundColor: brand.hex || "white",
                                color: brand.white ? "white" : "unset",
                              }}
                            >
                              Verify
                            </button>
                            <div className="edit">
                              <i className={"si si-check"} />
                            </div>
                          </div>
                          <div className="row_item">
                            <img
                              src={selfieIcon}
                              width="30"
                              alt="profession"
                            ></img>
                            <p className="row_item_value">Selfie check</p>
                            <button
                              className="btn verify_btn"
                              style={{
                                backgroundColor: brand.hex || "white",
                                color: brand.white ? "white" : "unset",
                              }}
                            >
                              Verify
                            </button>
                            <div className="edit">
                              <i className={"si si-check"} />
                            </div>
                          </div>
                          <div className="row_item">
                            <img src={idIcon} width="30" alt="profession"></img>
                            <p className="row_item_value">iD check</p>
                            <button
                              className="btn verify_btn"
                              style={{
                                backgroundColor: brand.hex || "white",
                                color: brand.white ? "white" : "unset",
                              }}
                            >
                              Verify
                            </button>
                            <div className="edit">
                              <i className={"si si-check"} />
                            </div>
                          </div> */}
                          <div className="row_item">
                            <img
                              src={profession_img}
                              width="30"
                              alt="profession"
                            ></img>
                            <p className="row_item_value">
                              {editfield === "profession" ? (
                                <div style={{ flex: 1 }}>
                                  <ReactSelect
                                    value={{
                                      label: editValue,
                                      value: editValue,
                                    }}
                                    onChange={(e) => {
                                      this.setState({ editValue: e.value });
                                    }}
                                    options={personal_profile.professions.map(
                                      (obj) => ({
                                        value: obj,
                                        label: obj,
                                      })
                                    )}
                                    isSearchable={false}
                                    styles={Styles}
                                  ></ReactSelect>
                                </div>
                              ) : (
                                personal_profile.profession || "Profession"
                              )}
                            </p>
                            <div
                              className="edit"
                              onClick={() =>
                                this.onChangePersonalProfileData("profession")
                              }
                            >
                              <i
                                className={
                                  editfield === "profession"
                                    ? "si si-check"
                                    : "si si-settings"
                                }
                              />
                            </div>
                          </div>
                          <div className="row_item">
                            <img
                              src={superhero_img}
                              width="30"
                              alt="super_skill"
                            ></img>
                            <p className="row_item_value">
                              {editfield === "super_skill" ? (
                                <div style={{ flex: 1 }}>
                                  <ReactSelect
                                    value={{
                                      label: editValue,
                                      value: editValue,
                                    }}
                                    onChange={(e) => {
                                      this.setState({ editValue: e.value });
                                    }}
                                    options={personal_profile.superskills.map(
                                      (obj) => ({
                                        value: obj,
                                        label: obj,
                                      })
                                    )}
                                    isSearchable={false}
                                    styles={Styles}
                                  ></ReactSelect>
                                </div>
                              ) : (
                                personal_profile.super_skill || "Super Skill"
                              )}
                            </p>
                            <div
                              className="edit"
                              onClick={() =>
                                this.onChangeProfileData("super_skill")
                              }
                            >
                              <i
                                className={
                                  editfield === "super_skill"
                                    ? "si si-check"
                                    : "si si-settings"
                                }
                              />
                            </div>
                          </div>
                          <input
                            type="file"
                            id="example-file-input"
                            ref="fileUploader"
                            name="example-file-input"
                            hidden
                            accept="image/*"
                            onChange={this.selectedFile}
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  )}

                  <VerificationModal
                    hex={brand_data.hex}
                    logo={brand_data.logo}
                    icon={brand_data.icon}
                    brand_data={brand_data}
                    smsSender={brand_data.name}
                    onSuccess={this.onSuccess}
                    modalNumber={modalNumber}
                    {...this.props}
                  />

                  <ErrorModal
                    caption={"Warning"}
                    content={"All fields are required!"}
                  />

                  <div className="profile__btn-container">
                    <button
                      onClick={this.props.history.goBack}
                      className="btn btn-white btn-brand-hex"
                      style={{
                        "--hover-color": brand_data.hex || "white",
                        "--hover-text-color": brand_data.white
                          ? "white"
                          : "black",
                      }}
                    >
                      Return
                    </button>
                    {!isLinked && (
                      <HexButton
                        className="btn profile__link-btn"
                        data-toggle="modal"
                        data-target="#phone_verification_modal"
                        onClick={() =>
                          this.setState((prev) => ({
                            ...prev,
                            modalNumber: prev.modalNumber + 1,
                          }))
                        }
                      >
                        Link your personal profile
                      </HexButton>
                    )}
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default Profile;



// WEBPACK FOOTER //
// ./src/screens/Profile/index.js